import * as React from 'react';
import { Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { ImageFromBlob } from '../../uiComponents/layout/ImageFromBlob';
import { Header } from '../../uiComponents/layout/Header';
import { LinkSectionButton } from '../../uiComponents/input/Buttons';
import { KonkurrenceOpgave } from '../../models/KonkurrenceOpgave';
import { Icon } from '../../uiComponents/Icon';
import { Image } from '../../uiComponents/layout/Image';

export interface OpgaveCardProps {
    opgave: KonkurrenceOpgave;
    konkurrenceId: string;
    opgavepakkeOpgaveId: string;
    isEnabled?: boolean;
    holdId?: string;
    showSamletPlacering: boolean;
    showResultatButton: boolean;
    kanBedoemme: boolean;
    erPaaVenteListeVisning?: boolean;
    erEkstern?: boolean;
}

class OpgaveCard extends React.Component<OpgaveCardProps, any> {
    constructor(props: OpgaveCardProps) {
        super(props);

        this.getOpgaveUrl = this.getOpgaveUrl.bind(this);
    }

    getBaseUrl(): string {
        return this.props.erEkstern ? `/konkurrence/${this.props.konkurrenceId}/opgavepakkeopgave/${this.props.opgavepakkeOpgaveId}`
         : `/konkurrence/${this.props.konkurrenceId}/hold/${this.props.holdId}/opgavepakkeopgave/${this.props.opgavepakkeOpgaveId}`;
    }

    getOpgaveUrl(): string {
        return `${this.getBaseUrl()}/opgave`;
    }

    getLogbogUrl(): string {
        return `${this.getBaseUrl()}/logbog`;
    }

    getOftestStilledeSpoergsmaalUrl(): string {
        return `${this.getBaseUrl()}/ofteststilledespoergsmaal`;
    }

    showRibbon() {
        let content = (<div />);

        if (this.props.showSamletPlacering && this.props.opgave.placering !== -1) {
            content = (
                <div className='placering-image-wrapper'>
                    <Image className='placering-image' source='placering.png' />
                    <p className='placering'>{this.props.opgave.placering}</p>
                </div>
            );
        }

        return content;
    }

    getLabel() {
        if (this.props.isEnabled) {
            if (this.props.opgave.gennemfoert) {
                return (<div className='opgave-card-state'>Gennemført <Icon className='success' name='success' /></div>);
            } else {
                return '';
            }
        } else {
            return (<div className='opgave-card-state'>Først tilgængelig på konkurrence dagen</div>);
        }
    }

    getResultatKnap() {
        if (this.props.showResultatButton && this.props.kanBedoemme && !this.props.erPaaVenteListeVisning) {
            return (
                <LinkSectionButton
                    className='opgave-card-primary-button'
                    url={'/opgave-bedoemmelse/' + this.props.konkurrenceId + '/' + this.props.opgave.id}
                    text={'Indtast resultater'}
                />
            );
        } else {
            return null;
        }
    }

    render() {
        let styleClasses = this.props.isEnabled ? 'opgave-card' : 'opgave-card opgave-card-disabled';

        return ( 
            <Col md={4} className={styleClasses}>
                <div className='opgave-card-wrapper'>
                    <div className='opgave-image-wrapper'>
                        <ImageFromBlob id={this.props.opgave.imageId} />
                        {this.showRibbon()}
                        {this.getLabel()}
                    </div>
                    <div className='opgave-card-title'>
                        <Header type='h1'>{this.props.opgave.titel}</Header>
                    </div>
                    <div className='opgave-card-button-group'>
                        <LinkSectionButton
                            className='opgave-card-button'
                            url={this.getOpgaveUrl()}
                            text='Opgave'
                            disabled={!this.props.isEnabled}
                        />
                        {(this.props.erEkstern !== true) 
                            && <LinkSectionButton className='opgave-card-button' url={this.getLogbogUrl()} text='Logbog' disabled={!this.props.isEnabled} />}
                        <LinkSectionButton className='opgave-card-button' url={this.getOftestStilledeSpoergsmaalUrl()} text='Oftest stillede spørgsmål' disabled={!this.props.isEnabled} />
                        {this.getResultatKnap()}
                    </div>
                </div>
            </Col>
        );
    }
}

export default OpgaveCard;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/OpgaveCard.tsx